import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Clock, AlertCircle } from 'lucide-react';

const TodayRotaSnapshot = () => {
  const [rota, setRota] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTodayRota = async () => {
      try {
        const res = await axios.get('/api/rota/today');
        setRota(res.data || []);
      } catch (err) {
        console.error('Failed to load today’s rota', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTodayRota();
  }, []);

  if (loading) {
    return <div className="text-sm text-gray-400">Loading today’s rota...</div>;
  }

  if (rota.length === 0) {
    return <div className="text-yellow-400">No staff scheduled for today.</div>;
  }

  return (
    <div className="bg-[#1e293b] p-4 rounded-2xl border border-[#334155] shadow-md text-white">
      <h3 className="text-lg font-bold mb-2 flex items-center gap-2">
        <Clock size={18} /> Today’s Rota Snapshot
      </h3>

      <div className="space-y-2 text-sm">
        {rota.map((entry) => (
          <div
            key={entry.staff_id}
            className={`flex justify-between items-center px-3 py-2 rounded-md ${
              entry.clocked_in
                ? 'bg-green-700/20 text-green-300'
                : 'bg-red-700/20 text-red-300'
            }`}
          >
            <div>
              <span className="font-medium">{entry.staff_name}</span> – {entry.shift_time}
            </div>
            {!entry.clocked_in && (
              <span className="flex items-center gap-1 text-sm">
                <AlertCircle size={14} /> Not Clocked In
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TodayRotaSnapshot;
